module.exports = __webpack_public_path__ + "img/logo_redbook_desktop.549ddb3c.png";